import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { DatePipe } from "@angular/common";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesStatus, MessagesSimuladorAgregarDetalle } from '../../../models/messages';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { FormControl, Validators } from '@angular/forms';


@Component({
  selector: 'app-nuevo-permiso',
  templateUrl: './nuevo-permiso.component.html',
  styleUrls: ['./nuevo-permiso.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesStatus, MessagesSimuladorAgregarDetalle]
})
export class NuevoPermisoComponent implements OnInit {
  @Output() cerrarListaAcceso: EventEmitter<boolean>;
  @Output() evento = new EventEmitter<number>();
  @Output() sistema = new EventEmitter<string>();
  selectControl = new FormControl('', [Validators.required]);
  abrirPermisoComponente: boolean = false;
  loading: boolean = false;
  isLoading: boolean = false;
  save: boolean = false;
  dataUser: any;
  id_sistema: any;
  id_rol: any;
  NombreRol: any;
  rol: any = [];
  repSistemas: any = [];
  repRoles: any = [];
  data: any = {};
  user: any;
  displayedColumns1 = ['Nombre', 'Rol', 'Action'];
  dataSource1: any;

  constructor(private securityService: SecurityService, private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus, private router: Router) {
    this.cerrarListaAcceso = new EventEmitter();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    try {
      this.dataUser = this.securityService.dataUser;
    } catch (error) {
      this.router.navigate(['/usuarios/listado']);
    }

  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
    this.ObtenerListaSistemas();
    this.ObtenerListaRoles();
  }

  ObtenerListaSistemas() {
    this.loading = true;
    this.securityService.ObtenerListaSistemas()
      .subscribe(resp => {
        this.repSistemas = resp
        this.dataSource1 = new MatTableDataSource(this.repSistemas);
        this.dataSource1.sort = this.sort;
        this.dataSource1.paginator = this.paginator;
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA SISTEMAS NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }

  ObtenerListaRoles() {
    this.loading = true;
    this.securityService.ObtenerListaRoles(this.user.id_empresa)
      .subscribe(resp => {
        this.repRoles = resp
        this.rol = this.repRoles;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA ROLES NO OBTENIDA. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }

  filterItemsOfId() {
    return this.rol.filter(x => x.id_sistemas == this.id_sistema);
  }

  changeClient(value: any) {
    this.id_rol = value.id_roles;
    this.NombreRol = value.Nombre;
  }


  VerComponentes(elemento: any) {

    this.data = elemento;
    if (this.data.id_sistemas == this.selectControl.value.id_sistemas) {
      this.abrirPermisoComponente = true;
      this.securityService.dataPermiso = this.data;
      this.securityService.dataPermisoRol = this.selectControl.value;
    } else {
      this.abrirPermisoComponente = false;
      Swal.fire({
        title: "Warning",
        text: "Seleccione un rol",
        type: "info",
        allowOutsideClick: false,
        heightAuto: false
      });
    }
  }

  FiltrarRol(element: any) {
    this.id_sistema = element;
    this.id_rol = '';
    this.NombreRol = '';
    this.filterItemsOfId();
  }


  CerrarPermisoComponente() {
    this.abrirPermisoComponente = false;
  }

}


